import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { DTicketLogo } from '../../../../icons/DTicketLogo';

import { StyledTicketFooterContainer, StyledTicketInfoSection } from './styled';

interface IMplDeutschlandTicketCardFooterProps {
	ticketId?: string;
	isBlurred?: boolean;
}

export const MplDeutschlandTicketCardFooter: FC<
	IMplDeutschlandTicketCardFooterProps
> = ({ ticketId, isBlurred = false }) => {
	const { t } = useTranslation('userDTicket');
	return (
		<StyledTicketFooterContainer isBlurred={isBlurred}>
			<StyledTicketInfoSection>
				<Typography variant="b2" color="solutions.600">
					{t('dticket_large.footer.ticket_id')}
				</Typography>
				<Typography
					variant="b1"
					color="primary.main"
					data-testid="dticket-ticket-id"
				>
					{ticketId || '-'}
				</Typography>
			</StyledTicketInfoSection>
			<DTicketLogo width={48} height={48} />
		</StyledTicketFooterContainer>
	);
};
